import * as React from 'react';
import { UIHeading4, UIText2 } from '@cian/ui-kit';

import * as styles from './RateTooltipContent.css';

export interface IRateTooltipContentProps {
  description: string;
  title: string;
}

export const RateTooltipContent: React.VFC<IRateTooltipContentProps> = ({ title, description }) => {
  return (
    <div className={styles['tooltip']}>
      <div className={styles['title']}>
        <UIHeading4 as="h3">{title}</UIHeading4>
      </div>
      <UIText2>{description}</UIText2>
    </div>
  );
};
